import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { catchError } from "rxjs/operators";
import { HandleHttpError } from 'src/app/core/utils/HttpHandleError';
@Injectable()
export class NeoTipoDocIdentidadService {
  public url: String;

  constructor(private _http: HttpClient) {
    this.url = environment.apiLocalUrl + 'neoTipoDocIdentidad/';
  }

  getTiposDocIdentidad(): Observable<any> {
    return this._http.get(this.url+"").pipe(catchError(HandleHttpError));
  }
}